import { useEffect, useState } from "react";
import { BtnPrimary, CancelBtn } from "../global/btns/btns";
import InputField from "../inputs/inputField";
import InputPassword from "../inputs/inputPassword";
import { updateDriver } from "../../store/drivers";
import { toggleRender } from "../../store/stateSlice";
import { useDispatch, useSelector } from "react-redux";
import UploadPhoto from "../inputs/UploadPhoto";
import { getOne } from "../../store/helper";
import { useNavigate } from "react-router-dom";

export const PersonalForm = ({ data }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const errorMsgStore = useSelector((state) => state.drivers.errorMsg);
  const [errorMsg, seterrorMsg] = useState(errorMsgStore);
  const [values, setValues] = useState({
    image: "",
    name: "",
    phone: "",
    email: "",
    viewPhoto: "",
    password: ""
  });
  useEffect(() => {
    setValues({
      ...values,
      name: data.name,
      phone: data.phone,
      email: data.email,
      password: data.password,
      image: data.image,
    })


  }, [])
  // State to store uploaded file
  const [file, setFile] = useState("");
  const handleChange = ({ target }) => {
    setValues({
      ...values,
      [target.name]: target.value,
      image: data.image,
    });

  }

  // Handles file upload event and updates state
  function handleUpload(e) {
    const file = e.target.files[0];
    setFile(file);
  }
  //function to sumbit data
  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(updateDriver({ ...values, id: data.id, })
    ).then((res) => {
      if (res.payload.status === 200) {
        dispatch(toggleRender());
        dispatch(getOne({ path: "/driver/profile/", id: data.id }))
      }
    })
  };

  //handel errormsg validation
  useEffect(() => {
    seterrorMsg(errorMsgStore)
  }, [errorMsgStore]);

  const handelError = (key) => {
    return (
      <span className="text-error"> {errorMsg !== null && errorMsg !== undefined ? errorMsg[key] : null} </span>
    )
  }
  return (
    <div className="personal__container">
      <from className="personal__form">
        <div className="personal__form-side">

          <InputField
            name="name"
            value={values.name}
            title='الاسم'
            placeholder='اكتب الاسم '
            onChange={handleChange}
            note='*'
          />
          {handelError("name")}

          <InputField
            name="email"
            value={values.email}
            onChange={handleChange}
            title='البريد الالكتروني'
            placeholder='اكتب البريد الالكتروني'
            type='email'
          />
          {/* {handelError("email")} */}
          <InputField
            name="phone"
            value={values.phone}
            onChange={handleChange}
            title='رقم الموبيل '
            placeholder='اكتب رقم الموبيل'
            note='*'
            type='number'
          />
          {handelError("phone")}
          <InputPassword
            name="password"
            value={values.password}
            onChange={handleChange}
            title='الرقم السري '
            placeholder='اكتب الرقم السري *'
            note='*'
          />
          {handelError("password")}
        </div>

      </from>
      <div
        className="flex-between"
        style={{ width: "80%", flexDirection: "row" }}
      >
        <BtnPrimary action="تعديل" click={handleSubmit} />
        <CancelBtn click={() => navigate("/drivers")} />
      </div>
    </div>
  );
};
